import PropTypes from 'prop-types';
import React, { CSSProperties } from 'react';

type IconProps = {
  w?: number;
  h?: number;
  style?: CSSProperties;
  className?: string;
  fill?: string;
};

function WhatsAppIcon({ w = 24, h = 24, fill, style, className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      fill={fill}
      style={style}
      viewBox="0 0 24 24"
      className={className}
    >
      <path
        fillRule="evenodd"
        d="M17.69 6.33A7.89 7.89 0 0 0 12.06 4a7.93 7.93 0 0 0-6.93 11.9L4 20l4.23-1.08a7.83 7.83 0 0 0 3.8.95c4.4 0 7.97-3.59 7.97-7.96a7.82 7.82 0 0 0-2.31-5.57zm-5.63 12.2c-1.17 0-2.35-.3-3.35-.9l-.26-.14-2.53.65.65-2.46-.17-.26a6.51 6.51 0 0 1 2.13-9.04c3.14-1.9 7.2-1 9.12 2.12a6.5 6.5 0 0 1-2.14 9.04c-1 .64-2.22.99-3.45.99zm3.84-4.8l-.48-.22s-.7-.3-1.13-.52c-.05 0-.09-.04-.13-.04a.63.63 0 0 0-.3.09l-.66.73a.24.24 0 0 1-.22.13h-.04a.33.33 0 0 1-.18-.08l-.22-.09a4.22 4.22 0 0 1-1.26-.82c-.09-.09-.22-.17-.3-.26-.31-.3-.62-.65-.83-1.04l-.05-.09c-.04-.04-.04-.08-.08-.17 0-.08 0-.17.04-.21 0 0 .17-.22.3-.35.1-.09.13-.22.22-.3.09-.13.13-.3.09-.44-.04-.21-.57-1.38-.7-1.64a.5.5 0 0 0-.3-.21h-.48c-.09 0-.18.04-.26.04l-.05.04c-.08.04-.17.13-.26.17-.09.1-.13.18-.22.26a2.2 2.2 0 0 0-.26 2.34l.04.13a7.2 7.2 0 0 0 1.62 2.2l.17.18c.13.13.26.21.35.34a7.81 7.81 0 0 0 3.14 1.65c.13.04.3.04.44.08h.43c.22 0 .48-.08.66-.17.13-.09.21-.09.3-.17l.09-.09c.09-.09.17-.13.26-.22.09-.08.17-.17.22-.26.09-.17.13-.38.17-.6v-.3s-.04-.05-.13-.09z"
      />
    </svg>
  );
}

export default WhatsAppIcon;
